import type {
  MouseClickIXType,
  MouseHoverIXType,
  MouseMoveIXType,
  ScrollIntoViewIXType,
  ScrollingInViewIXType,
  PageLoadIXType,
  MouseMoveInViewportIXType,
  PageScrolledIXType,
  PageIsScrollingIXType,
  DropdownIXType,
  NavbarIXType,
  SliderIXType,
  TabIXType,
  // Shared
  InteractionId,
} from '@packages/systems/ix2/types-core';

import {InteractionTypeConsts} from '@packages/systems/ix2/shared-constants';

const {
  MOUSE_CLICK_INTERACTION,
  MOUSE_HOVER_INTERACTION,
  MOUSE_MOVE_INTERACTION,
  SCROLL_INTO_VIEW_INTERACTION,
  SCROLLING_IN_VIEW_INTERACTION,
  MOUSE_MOVE_IN_VIEWPORT_INTERACTION,
  PAGE_IS_SCROLLING_INTERACTION,
  PAGE_LOAD_INTERACTION,
  PAGE_SCROLLED_INTERACTION,
  NAVBAR_INTERACTION,
  DROPDOWN_INTERACTION,
  TAB_INTERACTION,
  SLIDER_INTERACTION,
} = InteractionTypeConsts;

/**
 * Interaction Records
 */

const defaultInteractionId = '' as InteractionId;

export const defaultMouseClickIX: MouseClickIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: MOUSE_CLICK_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string, string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as MouseClickIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultMouseHoverIX: MouseHoverIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: MOUSE_HOVER_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string, string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as MouseHoverIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultMouseMoveIX: MouseMoveIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: MOUSE_MOVE_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as MouseMoveIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultScrollIntoViewIX: ScrollIntoViewIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: SCROLL_INTO_VIEW_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string, string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as ScrollIntoViewIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultScrollingInViewIX: ScrollingInViewIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: SCROLLING_IN_VIEW_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as ScrollingInViewIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultPageLoadIX: PageLoadIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: PAGE_LOAD_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string, string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as PageLoadIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultMouseMoveInViewportIX: MouseMoveInViewportIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: MOUSE_MOVE_IN_VIEWPORT_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as MouseMoveInViewportIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultPageScrolledIX: PageScrolledIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: PAGE_SCROLLED_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string, string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as PageScrolledIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultPageIsScrollingIX: PageIsScrollingIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: PAGE_IS_SCROLLING_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as PageIsScrollingIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultDropdownIX: DropdownIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: DROPDOWN_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string, string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as DropdownIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultNavbarIX: NavbarIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: NAVBAR_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string, string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as NavbarIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultSliderIX: SliderIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: SLIDER_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string, string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as SliderIXType['eventIds'],
  target: null,
  createdOn: null,
};

export const defaultTabIX: TabIXType = {
  id: defaultInteractionId,
  origin: undefined,
  interactionTypeId: TAB_INTERACTION,
  // @ts-expect-error - TS2352 - Conversion of type 'null' to type '[string, string]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  eventIds: null as TabIXType['eventIds'],
  target: null,
  createdOn: null,
};
